// src/components/recheck/recheckKeys.js
//
// The re-check page's keys: the list the ? overlay renders (WellFinder
// Review's ShortcutHelp, given this list) and the resolver the page's handler
// reads, so the help cannot describe a key the page does not have.
// RecheckPage.keymap.test.jsx holds each description against what the key
// does.

export const RECHECK_KEY_GROUPS = ["Navigate", "Position", "Help"];

export const RECHECK_KEY_ACTIONS = Object.freeze([
  {
    keys: ["j"], id: "next", label: "Next item", group: "Navigate",
    detail: "Opens the next item in the cell, on its own collect. A corrected position not yet confirmed is discarded, with a notice.",
  },
  {
    keys: ["k"], id: "prev", label: "Previous item", group: "Navigate",
    detail: "Opens the previous item in the cell, on its own collect. A corrected position not yet confirmed is discarded, with a notice.",
  },
  {
    keys: ["m"], id: "move", label: "Correct position", group: "Position",
    detail: "Starts a corrected position at the item's point: drag the marker, then Confirm. Only with the cell's lock, on the item's own collect, before a verdict.",
  },
  {
    keys: ["Esc"], id: "cancel", label: "Close or discard", group: "Position",
    detail: "Closes this key map when it is open; otherwise discards the corrected position.",
  },
  {
    keys: ["?"], id: "help", label: "Key map", group: "Help",
    detail: "Opens and closes this list.",
  },
]);

/**
 * A KeyboardEvent to an action id, or null. Nothing acts while typing in a
 * field, ? included.
 */
export function resolveRecheckKey(e) {
  const tag = e.target?.tagName;
  if (tag === "TEXTAREA" || tag === "INPUT") return null;
  switch (e.key) {
    case "j": return "next";
    case "k": return "prev";
    case "m": return "move";
    case "Escape": return "cancel";
    case "?": return "help";
    default: return null;
  }
}
